export const USER_CLICKED_OBTAIN_LICENSE= 'userClickedObtainLicense'



// WEBPACK FOOTER //
// ./web/js/userEvents/constant.js